export const generateTrackingId = () => {
        return 'TRK_' + Date.now() + '_' + Math.floor(Math.random() * 10000);
    };
 